import cx from "clsx";
import SizingContainer from "common-utils/components/SizingContainer";
import { GalleryArtwork } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import React from "react";

import styles from "./index.module.scss";

import { EM_DASH } from "@/modules/common-utils/unicode";
import SecondaryFileViewer from "@/modules/kreate-components/components/SecondaryFileViewer";
import UserDisplayNameViewerV2 from "@/modules/kreate-components/components/UserDisplayNameViewerV2";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  galleryArtwork: GalleryArtwork;
};

export default function SmallGalleryArtworkViewer({
  className,
  style,
  galleryArtwork,
}: Props) {
  const artist = galleryArtwork?.kreateArtwork?.populated?.createdBy;

  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Row gap="12px" flex="0 1 auto" minWidth="0">
        <Flex.Row flex="0 0 auto">
          <SizingContainer
            className={styles.imageContainer}
            sizing={{ type: "fixed", width: "48px", height: "48px" }}
          >
            <SecondaryFileViewer
              file={galleryArtwork.file}
              thumbnailFile={galleryArtwork.imageFile}
              sizes="48px"
              objectFit="contain"
              fill
            />
          </SizingContainer>
        </Flex.Row>
        <Flex.Col gap="4px" flex="0 1 auto" minWidth="0">
          <Flex.Cell className={styles.assetTitle}>
            {galleryArtwork.title || EM_DASH}
          </Flex.Cell>
          <Flex.Row className={styles.assetArtist} gap="0.5ch">
            <em>{"By"}</em>
            <Flex.Cell flex="0 1 auto" minWidth="0" asChild>
              <UserDisplayNameViewerV2 as="span" user={artist} unstyled />
            </Flex.Cell>
          </Flex.Row>
        </Flex.Col>
      </Flex.Row>
    </div>
  );
}
